module.exports = __webpack_public_path__ + "img/downloadIcon_.230f304b.png";